var map = {
	"./cash.png": "c342",
	"./maestro.png": "1135",
	"./mastercard.png": "8945",
	"./mir.png": "2ce1",
	"./new_card.png": "32b1",
	"./nspk mir.png": "d1c4",
	"./sbp.png": "795f",
	"./union.png": "aabf",
	"./visa.png": "226e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "122c";